import { render, staticRenderFns } from "./RecommendAudience.vue?vue&type=template&id=729be5ca&scoped=true"
import script from "./RecommendAudience.vue?vue&type=script&lang=js"
export * from "./RecommendAudience.vue?vue&type=script&lang=js"
import style0 from "./RecommendAudience.vue?vue&type=style&index=0&id=729be5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729be5ca",
  null
  
)

export default component.exports